import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FormatListBulletedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"format_list_bulleted"}/>
}
